module.exports = __webpack_public_path__ + "static/media/gautam.9d6e1ca5.png";